import envConfig from '../envs/envConfig';
import stripPathWithAsterisk from './stripPathWithAsterisk';

export default (location) => {
  const currentRoute = envConfig.remoteRoutes.find((route) =>
    location.pathname.startsWith(stripPathWithAsterisk(route.path))
  );

  return currentRoute?.productId;
};
